import { TestExecutor } from "./TestFramework";
import { TestRequestGet, TestRequestGetNotFound } from "./tests/ERequestTests";

// TODO: automate
export const TEST_CASES: readonly (() => TestExecutor)[] =
[
    TestRequestGet,
    TestRequestGetNotFound
];
